export const namespaced = true;

export const state = {
    elements: [],
    element: {},
    element_group: {},
    element_materials: [],
    element_sizes: [],
    types: [],
    type: null,
    sort: null,
    meta: null,
    page: 1,
    per_page: 25,
    loading: false,
}

export const mutations = {
    FETCH_ELEMENTS(state, elements) {
        state.elements = elements;
    },
    FETCH_ELEMENT(state, element) {
        state.element = element;
    },
    FETCH_ELEMENT_GROUP(state, element_group) {
        state.element_group = element_group;
    },
    FETCH_ELEMENT_MATERIALS(state, element_materials) {
        state.element_materials = element_materials.filter(m => m);
    },
    ADD_ELEMENT_MATERIAL(state, element_material) {
        state.element_materials.unshift(element_material);
    },
    REMOVE_ELEMENT_MATERIAL(state, material_id) {
        state.element_materials = state.element_materials.filter(material => material.data.material_id != material_id);
    },
    FETCH_ELEMENT_SIZES(state, element_sizes) {
        state.element_sizes = element_sizes;
    },
    FETCH_META(state, meta) {
        state.meta = meta;
    },
    FETCH_TYPES(state, types) {
        state.types = types;
    },
    ADD_ELEMENT(state, element) {
        state.elements.unshift(element);
    },
    SET_PAGE(state, page) {
        state.page = page;
    },
    SET_PER_PAGE(state, per_page) {
        state.per_page = per_page;
    },
    SET_TYPE(state, type) {
        state.type = type;
    },
    SET_SORT(state, sort) {
        state.sort = sort;
    },
    ELEMENTS_REMOVE(state) { },
    ELEMENTS_BLOCK(state) { },

    CLEAR_ELEMENT_SIZES_AND_MATERIALS(state) {
        state.element_materials = [];
        state.element_sizes = [];
    },
}

export const actions = {

    async fetch({ commit, state, dispatch }) {
        const params = {
            page: state.page,
            type: state.type,
            per_page: state.per_page
        };
        if (state.sort) {
            params['sort'] = state.sort.value;
            if (state.sort.desc) {
                params['desc'] = 1;
            }
        }
        try {
            const res = (await axios.get(`/api/admin/elements/${state.element_group.data.attributes.slug}`, { params })).data;
            commit('FETCH_ELEMENTS', res.data);
            commit('FETCH_META', res.meta);
            return res.data;
        } catch (error) {
            const notification = {
                element: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })
        }
    },

    async fetchElement({ commit, state, dispatch }, { element_group_slug, element_id }) {
        try {
            const res = (await axios.get(`/api/admin/elements/${element_group_slug}/${element_id}`)).data;
            const element = res.data && res.data.element;

            if (!element) {
                throw new Error('Элемент не найден');
            }

            commit('FETCH_ELEMENT', element);

            const materials = element.data && element.data.attributes && element.data.attributes.materials;
            const sizes = element.data && element.data.attributes && element.data.attributes.sizes;

            commit('FETCH_ELEMENT_MATERIALS', materials || []);
            commit('FETCH_ELEMENT_SIZES', sizes || []);

            return element;
        } catch (error) {
            const notification = {
                type: 'error',
                message: (error.response && error.response.data && error.response.data.message) || error.message
            }
            dispatch('notification/add', notification, { root: true })
        }
    },

    async fetchElementGroup({ commit, state, dispatch }, element_group_slug) {
        try {
            const res = (await axios.get(`/api/admin/element_groups/${element_group_slug}`)).data;
            commit('FETCH_ELEMENT_GROUP', res.data.element_group);
            return res.data.element_group;
        } catch (error) {
            const notification = {
                element: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })
        }
    },

    async fetchTypes({ commit, state, dispatch }, element_group_slug) {

        try {
            const res = (await axios.get(`/api/admin/elements/${element_group_slug}/types`)).data;
            commit('FETCH_TYPES', res.data);
            return res.data;
        } catch (error) {
            const notification = {
                type: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })
        }
    },

    async fetchMainMaterials({ commit, state, dispatch }) {

        try {
            const res = (await axios.get(`/api/admin/main-materials`)).data;
            commit('FETCH_ELEMENT_MATERIALS', res.data);
            return res.data;
        } catch (error) {
            const notification = {
                type: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })
        }
    },

    addElementMaterial({ commit, dispatch }, material) {
        commit('ADD_ELEMENT_MATERIAL', material);
    },

    removeElementMaterial({ commit, dispatch }, material_id) {
        commit('REMOVE_ELEMENT_MATERIAL', material_id);
    },

    setPage({ commit, state, dispatch }, page) {
        commit('SET_PAGE', page);
    },

    setPerPage({ commit, state, dispatch }, per_page) {
        commit('SET_PAGE', 1);
        commit('SET_PER_PAGE', per_page);
    },

    setType({ commit, state, dispatch }, type) {
        commit('SET_PAGE', 1);
        commit('SET_TYPE', type);
    },

    setSort({ commit, state, dispatch }, sort) {
        commit('SET_PAGE', 1);
        commit('SET_SORT', sort);
    },

    async copy({ commit, state, dispatch }, deletes) {
        if (deletes.length) {
            try {
                let formDataPost = new FormData();

                for (const i of deletes) {
                    formDataPost.append('copies[]', i);
                }

                await axios.post(
                    `/api/admin/copy-elements`, formDataPost
                );

                dispatch('fetch', state.element_group.data.attributes.slug);

                const notification = {
                    element: "success",
                    message: "Запрос успешно выполнен",
                };
                dispatch("notification/add", notification, { root: true });
            } catch (error) {
                const notification = {
                    element: 'error',
                    message: error.response && error.response.data && error.response.data.message
                }
                dispatch('notification/add', notification, { root: true });
                throw error;
            }
        } else {
            const notification = {
                element: 'error',
                message: 'Вы не выбрали ни одного типа'
            }
            dispatch('notification/add', notification, { root: true });
        }
    },

    async copySingle({ commit, state, dispatch }, elementId) {

        try {
            const res = await axios.post(`/api/admin/copy-element/${elementId}`);

            const notification = {
                type: "success",
                message: "Копирование успешно выполнено",
            };
            dispatch("notification/add", notification, { root: true });

            return res.data.data;

        } catch (error) {
            const notification = {
                type: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true });
            throw error;
        }
    },

    async block({ commit, state, dispatch }, { deletes, status }) {
        if (deletes.length) {
            try {
                let formDataPost = new FormData();

                for (const i of deletes) {
                    formDataPost.append('blocked[]', i);
                }
                formDataPost.append('status', status);

                const res = (
                    await axios.post(
                        `/api/admin/block-elements`, formDataPost
                    )
                ).data;

                commit('ELEMENTS_BLOCK');

                dispatch('fetch', state.element_group.data.attributes.slug);

                const notification = {
                    element: "success",
                    message: "Запрос успешно выполнен",
                };
                dispatch("notification/add", notification, { root: true });
            } catch (error) {
                const notification = {
                    element: 'error',
                    message: error.response && error.response.data && error.response.data.message
                }
                dispatch('notification/add', notification, { root: true });
                throw error;
            }
        } else {
            const notification = {
                element: 'error',
                message: 'Вы не выбрали ни одного типа'
            }
            dispatch('notification/add', notification, { root: true });
        }
    },

    async remove({ commit, state, dispatch }, deletes) {
        if (deletes.length) {
            try {
                let formDataPost = new FormData();

                for (const i of deletes) {
                    formDataPost.append('deletes[]', i);
                }

                const res = (
                    await axios.post(
                        `/api/admin/delete-elements`, formDataPost
                    )
                ).data;
                commit('ELEMENTS_REMOVE');

                dispatch('fetch', state.element_group.data.attributes.slug);

                const notification = {
                    element: "success",
                    message: "Удаление прошло успешно",
                };
                dispatch("notification/add", notification, { root: true });
            } catch (error) {
                const notification = {
                    element: 'error',
                    message: error.response && error.response.data && error.response.data.message
                }
                dispatch('notification/add', notification, { root: true });
                throw error;
            }
        } else {
            const notification = {
                element: 'error',
                message: 'Вы не выбрали ни одного типа'
            }
            dispatch('notification/add', notification, { root: true });
        }
    },

    clearElementSizesAndMaterials({ commit }) {
        commit('CLEAR_ELEMENT_SIZES_AND_MATERIALS');
    }
}
